// main.js 或者一个 Vue 插件文件中

import Vue from 'vue'
import store from '@/store'
Vue.directive('hasPermi', {
    // 指令的绑定钩子函数
    bind(el, binding) {
        const { value } = binding  // 获取指令传递的参数（权限标识）
        const all_permission = '*:*:*'  // 所有权限的标识（通配符，表示拥有所有权限）
        // 从 localStorage 中获取用户信息
        // const userInfo = JSON.parse(localStorage.getItem('userInfo'))
        // if (!userInfo || !userInfo.PermissionList) {
        //   console.error('用户信息或权限列表不存在')
        //   return
        // }

        // 获取用户的权限列表
        const permissions = store.state.user.permissionList
        // 判断指令传递的 value 是否为一个非空数组
        if (value && value instanceof Array && value.length > 0) {
            const permissionFlag = value  // 权限标识数组

            // 检查用户权限中是否有符合要求的权限
            const hasPermissions = permissions.some(permission => {
                // 如果有任意一个权限匹配（包括通配符权限 *:*:*）
                return all_permission === permission || permissionFlag.includes(permission)
            })

            // 如果没有权限，移除该元素
            if (!hasPermissions) {
                if (el) {
                    console.log(el);
                    el.style.display = 'none';
                } else {
                    console.log('元素不存在，无法移除');
                }
            }
        } else {
            // 如果没有传递有效的权限标识，抛出错误
            throw new Error('没有权限')
        }
    }
})
